export default __webpack_public_path__ + "static/media/home-architecture-slider-02.0db6a8e6.jpg";